import { render, staticRenderFns } from "./reviewshow.vue?vue&type=template&id=377ea16e&scoped=true&"
import script from "./reviewshow.vue?vue&type=script&lang=js&"
export * from "./reviewshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377ea16e",
  null
  
)

export default component.exports